export default function DevicesBaseController() {

  'ngInject';

}